const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

const shouldParseJson = (answer: string): boolean => {
  return answer.startsWith('[') || answer.startsWith('{') || answer.startsWith('"')
}

const parseJsonAnswer = (answer: string): unknown => {
  try {
    return JSON.parse(answer) as unknown
  } catch (error) {
    if (error instanceof SyntaxError) return answer

    throw error
  }
}

const normalizeStringAnswer = (answer: string): string[] => {
  const trimmedAnswer = answer.trim()
  if (!trimmedAnswer) return []

  if (shouldParseJson(trimmedAnswer)) return normalizeListAnswer(parseJsonAnswer(trimmedAnswer))

  return [answer]
}

const normalizeRecordAnswer = (answer: Record<string, unknown>): string[] => {
  if (answer.items !== undefined) return normalizeListAnswer(answer.items)
  if (answer.label !== undefined) return normalizeListAnswer(answer.label)
  if (answer.value !== undefined) return normalizeListAnswer(answer.value)

  return Object.values(answer).flatMap(normalizeListAnswer)
}

export const normalizeListAnswer = (answer: unknown): string[] => {
  if (answer === undefined || answer === null || answer === '') return []

  if (Array.isArray(answer)) {
    return answer.flatMap(normalizeListAnswer)
  }

  if (typeof answer === 'string') return normalizeStringAnswer(answer)

  if (typeof answer === 'number' || typeof answer === 'boolean') {
    return [String(answer)]
  }

  if (isRecord(answer)) return normalizeRecordAnswer(answer)

  return []
}

export const formatReportListAnswer = (answer: unknown): string => {
  return normalizeListAnswer(answer).join(', ')
}
